import { useParams } from "react-router";
import FileManager from "components/file-manager/file-manager";

export default function ClaimantDetailsViewFiles() {
    const params = useParams();
    return (
        <FileManager
            caseSlug={params.slug}
            institutionId={params.institutionId ? parseInt(params.institutionId) : undefined}
            fundId={params.fundId ? parseInt(params.fundId) : undefined}
        />
    );
}